import { useMemo } from 'react';
import { getAssignmentConflicts, getAggregatedConflictSummary } from '../../../../../utils/leaderUtils';

/**
 * Hook to build a map of assignment IDs to their conflict status and reasons.
 */
export function useCalendarConflicts({
    assignments,
    assignmentsForConflicts,
    absencesForConflicts,
    workers,
    vehicles,
    kolonnen
}) {
    return useMemo(() => {
        const map = {};
        if (!assignments || !assignmentsForConflicts || !absencesForConflicts) return map;

        assignments.forEach(a => {
            if (!a.id || a.isGhost) return;
            const conflicts = getAssignmentConflicts(a, assignmentsForConflicts, absencesForConflicts, vehicles);
            if (conflicts.total > 0) {
                const summary = getAggregatedConflictSummary(a, conflicts, workers, vehicles, kolonnen);
                const finalReasons = [];
                
                Object.keys(summary.kolonnen).forEach(kId => {
                    const k = kolonnen.find(x => String(x.id) === kId);
                    const kName = k?.internal_name || k?.name || 'Kolonne';
                    const msgs = Array.from(summary.kolonnen[kId]).map(m => m.replace('Doppelbelegung mit Einsatz:', 'Doppelbelegung mit'));
                    finalReasons.push(`• Kolonne "${kName}": ${msgs.join(', ')}`);
                });
                
                summary.individuals.forEach(msg => {
                    finalReasons.push(`• ${msg}`);
                });

                map[a.id] = {
                    hasConflict: true,
                    reasonText: `⚠️ Konflikte in diesem Termin:\n${finalReasons.join('\n')}`
                };
            }
        });
        return map;
    }, [assignments, assignmentsForConflicts, absencesForConflicts, vehicles, workers, kolonnen]);
}
